export const ASIACHANGETRIP = 'ASIACHANGETRIP'

export const ASIAADDADULT = 'ASIAADDADULT'

export const ASIAMINUSADULT = 'ASIAMINUSADULT'

export const ASIAADDCHILDREN = 'ASIAADDCHILDREN'

export const ASIAMINUSCHILDREN = 'ASIAMINUSCHILDREN'

export const ASIAPICKDATE = 'ASIAPICKDATE'

export const ASIAADDTOCART = 'ASIAADDTOCART'

export const ASIAREMOVEFROMCART = 'ASIAREMOVEFROMCART'

export const ASIAAIRPORTPICKUP = 'ASIAAIRPORTPICKUP'

export const ASIADIFFERENTHOTEL = 'ASIADIFFERENTHOTEL'

export const ASIAMORETRIPS = 'ASIAMORETRIPS'

export const ASIAREMOVEALL = 'ASIAREMOVEALL'